import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), 'LaunchSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LaunchSharp.js
// module id = 4428
// module chunks = 2